// Social link definitions
import { SocialIconType } from '../components/Icon';
import { hyperlinks } from './Hyperlinks';

export interface SocialLinkDef {
    title: string;
    url: string;
    iconType: SocialIconType;
}

export const SOCIAL_LINK_DEFS: SocialLinkDef[] = [
    {
        ...hyperlinks.klimMastodon,
        iconType: SocialIconType.MASTODON,
    },
    {
        ...hyperlinks.klimInstagram,
        iconType: SocialIconType.INSTAGRAM,
    },
    {
        ...hyperlinks.klimVimeo,
        iconType: SocialIconType.VIMEO,
    },
    {
        ...hyperlinks.klimTumblr,
        iconType: SocialIconType.TUMBLR,
    },
    {
        ...hyperlinks.klimPinterest,
        iconType: SocialIconType.PINTEREST,
    },
    {
        ...hyperlinks.klimFlickr,
        iconType: SocialIconType.FLICKR,
    },
];
